<template>
  <NoCompanyAttest v-if="userInfo.manage === 0" />
  <div style="position:relative;" v-else>
    <el-tabs v-model="activeName" class="listTabs">
      <el-tab-pane label="" name="facebook" v-if="rolePermission('FacebookAccount')">
        <template #label>
          <span id="firstStep">Facebook</span>
        </template>
        <UserAccountList v-if="activeName === 'facebook'" />
      </el-tab-pane>
      <el-tab-pane label="TikTok" name="tiktok" v-if="rolePermission('TTAccount')">
        <TTAccountList v-if="activeName === 'tiktok'" />
      </el-tab-pane>
      <el-tab-pane label="微软广告" name="bing" v-if="rolePermission('BingAccount')">
        <BingAccountList v-if="activeName === 'bing'" />
      </el-tab-pane>
      <el-tab-pane label="Google" name="google" v-if="rolePermission('GGAccount')">
        <GGAccountList v-if="activeName === 'google'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import TTAccountList from '../tiktok/users/account/TTAccountList.vue'
import UserAccountList from '../users/accountList/UserAccountList.vue'
import GGAccountList from '../accountManage/google/GGAccountList.vue'
import BingAccountList from '@/views/account/manage/bing/Index'
import { getAccountPermission } from '@/request/api/business'
import NoCompanyAttest from '../base/NoCompanyAttest.vue'

export default {
  name: 'ListAccount',
  components: {
    TTAccountList,
    UserAccountList,
    GGAccountList,
    BingAccountList,
    NoCompanyAttest
  },
  props: ['tabsType'],
  data() {
    return {
      activeName: '',
      accountPermissionPage: [],
      userInfo: this.$store.getters.userInfo
    }
  },
  methods: {
    rolePermission(node) {
      if (this.$store.getters.userInfo.manage === 1) return true
      let permission = this.accountPermissionPage || this.$store.getters.rolePermission
      let result = permission.includes(node)
      return result
    }
  },
  mounted() {
    getAccountPermission().then(res => {
      this.accountPermissionPage = res?.data
      if (!res?.data.includes('FacebookAccount')) {
        if (!res?.data.includes('TTAccount')) {
          if (!res?.data.includes('BingAccount')) {
            if (!res?.data.includes('GGAccount')) {
              this.activeName = 'facebook'
            } else {
              this.activeName = 'google'
            }
          } else {
            this.activeName = 'bing'
          }
        } else {
          this.activeName = 'tiktok'
        }
      } else {
        this.activeName = 'facebook'
      }
    })
    if (this.tabsType === 'tiktok') {
      this.activeName = 'tiktok'
    } else if (this.tabsType === 'bing') {
      this.activeName = 'bing'
    } else if (this.tabsType === 'google') {
      this.activeName = 'google'
    }
  },
}
</script>

<style lang="less" scoped>
.listTabs {
  :deep(.el-tabs__header) {
    background: #fff;
    margin-bottom: 20px !important;

    .el-tabs__nav-wrap {
      padding-left: 20px;
    }
  }
}
</style>
